module.exports = __webpack_public_path__ + "static/media/outbox.ca31c753.svg";